import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, props } from 'cerebral/tags'
import isUploading from 'utils/isUploading'
import { css } from 'aphrodite'
import styles from './styles'

export default connect(
  {
    file: state`${props`path`}`,
    dragging: state`media.dragging`
  },
  class EventButton extends Component {
    render() {
      const { file, dragging, path } = this.props
      const uploading = isUploading(file)
      const { enter, selected, removed } = file

      if (!enter || dragging || removed || uploading) {
        return null
      }
      const fill = selected ? '#0069b4' : '#868686'
      return (
        <div className={css(styles.container)}>
          <svg style={{ cursor: 'pointer', width: 40, height: 40 }}>
            <polygon points={'0 0, 40 0, 0,40'} fill={fill} stroke={fill} />
          </svg>
          {this.props.render({
            selected,
            uploading,
            path
          })}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/File/EventButton/eventButton.js